export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      children: [
        {
          name: 'Risk Management Series - Professional Liability',
          url: '/dashboard',
          icon: 'icon-list',
        },
        {
          name: 'How to structure your e-commerce business in the latest global tax landscape Event Flyer',
          url: '/dashboard?event001',
          icon: 'icon-list',
        },
        {
          name: 'Professional Liability Part III - Claims from your Customers',
          url: '/dashboard?event002',
          icon: 'icon-list',
        },
      ],
    },
    {
      title: true,
      name: 'Features',
    },
    {
      name: 'Welcome',
      url: '/welcome',
      icon: 'icon-star',
    },
    {
      name: 'Biography',
      url: '/biography',
      icon: 'icon-user',
    },
    {
      name: 'Agenda',
      url: '/agenda',
      icon: 'icon-calendar',
    },
    {
      name: 'Feedback',
      url: '/feedback',
      icon: 'icon-question',
    },
    {
      name: 'Theme',
      url: '/theme',
      icon: 'icon-grid',
    },
  ]
};



// WEBPACK FOOTER //
// ./src/_nav.js